import styled from 'styled-components'

interface ICustomTaxSelectStyledProps {}

export const CustomTaxSelectStyled = styled.div<ICustomTaxSelectStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
